module.exports = __webpack_public_path__ + "static/media/B-Triads.ec58087b.png";